// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"132":"239a47b4","354":"ee14a1a0","838":"a37d5474"}[chunkId] + ".js";
};